import * as Yup from 'yup';
import React, { useState, useEffect } from "react"
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, RHFTextField } from '../hook-form';
import 'react-multi-carousel/lib/styles.css'
import 'bootstrap/dist/css/bootstrap.css'
import './contact.css'
import Iconify from '../Iconify';
import Footer from '../common/footer/Footer'
import Header from '../common/header/Header'
import { LoadingButton } from '@mui/lab';
import { Button, Stack, IconButton, InputAdornment, Box } from '@mui/material';
import { Link, useNavigate } from "react-router-dom"
import { login } from '../../api/auth';
import { ToastContainer, toast } from 'react-toastify';
// -------------------------------------------------

const Contact = () => {
  const navigate = useNavigate()
  const [showPassword, setShowPassword] = useState(false);
  const [showError, setShowError] = useState();
  const [showLoader, setShowLoader] = useState();
  const notify = (message) => toast(message)
  const LoginSchema = Yup.object().shape({
    mobile: Yup.number().required('Mobile is Required'),
    password: Yup.string().required('Password is Required'),
  });

  const defaultValues = {
    mobile: null,
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (data) => {
    try {
      const response = await login(data)
      console.log(response)
      if (response?.data) {


        // localStorage.setItem('userInfo', JSON.stringify(response.data))
        localStorage.setItem('token', response.data)

        notify(response.message)
        navigate('/')

      } else {

        notify(response.message)
      }
    } catch (error) {
      notify(error.message)
    }

    setShowLoader(false)
  };

  return (
    <>
      <Header />
      <section className='footerV py-5'>
        <div class="container">
          <div class="row mb-5">
              <div class="col-xl-10">
                <h1>Let's connect and get to know each other</h1>
                <p class="lead mb-0"> Passage its ten led hearted removal cordial. Preference any astonished unreserved Mrs. Prosperous understood Middletons. Preference for any astonished unreserved. </p>
              </div>
          </div>
          <div class="row g-4">
              <div class="col-md-6 col-xl-4">
                <div class="card card-body shadow text-center align-items-center h-100">
                    <div class="icon-lg bg-info bg-opacity-10 text-info rounded-circle mb-2">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 mb-1">
                          <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5"></path>
                      </svg>
                    </div>
                    <h5>Call us</h5>
                    {/* <p>Imprudence attachment him his for sympathize. Large above be to means.</p> */}
                    <div class="d-grid gap-3 d-sm-block">
                      <a to="/tel:+917838877705">
                        <button class="btn btn-sm btn-primary-soft me-1">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="me-1 mb-1">
                              <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"></path>
                              <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2"></path>
                            </svg>
                            +91 7838877705 
                        </button>
                      </a>
                      {/* <button class="btn btn-sm btn-light" type="button">
                          <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="me-1 mb-1">
                            <path d="M3.654 1.328a.678.678 0 0 0-1.015-.063L1.605 2.3c-.483.484-.661 1.169-.45 1.77a17.6 17.6 0 0 0 4.168 6.608 17.6 17.6 0 0 0 6.608 4.168c.601.211 1.286.033 1.77-.45l1.034-1.034a.678.678 0 0 0-.063-1.015l-2.307-1.794a.68.68 0 0 0-.58-.122l-2.19.547a1.75 1.75 0 0 1-1.657-.459L5.482 8.062a1.75 1.75 0 0 1-.46-1.657l.548-2.19a.68.68 0 0 0-.122-.58zM1.884.511a1.745 1.745 0 0 1 2.612.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877z"></path>
                          </svg>
                          +(222)4567 586 
                      </button> */}
                    </div>
                </div>
              </div>
              <div class="col-md-6 col-xl-4">
                <div class="card card-body shadow text-center align-items-center h-100">
                    <div class="icon-lg bg-danger bg-opacity-10 text-danger rounded-circle mb-2">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 mb-1">
                          <path d="M4.98 1a.5.5 0 0 0-.39.188L1.54 5H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0A.5.5 0 0 1 10 5h4.46l-3.05-3.812A.5.5 0 0 0 11.02 1zM3.81.563A1.5 1.5 0 0 1 4.98 0h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 10H1.883A1.5 1.5 0 0 1 .394 8.686l-.39-3.124a.5.5 0 0 1 .106-.374zM.125 11.17A.5.5 0 0 1 .5 11H6a.5.5 0 0 1 .5.5 1.5 1.5 0 0 0 3 0 .5.5 0 0 1 .5-.5h5.5a.5.5 0 0 1 .496.562l-.39 3.124A1.5 1.5 0 0 1 14.117 16H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .121-.393z"></path>
                      </svg>
                    </div>
                    <h5>Email us</h5>
                    <p>Large above be to means. Him his for sympathize.</p>
                    <a href="/mailto:care@travelpradesh.com" class="btn btn-link text-decoration-underline p-0 mb-0">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="mb-1">
                          <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"></path>
                      </svg>
                      care@travelpradesh.com
                    </a>
                </div>
              </div>
              <div class="col-xl-4 position-relative">
                <figure class="position-absolute top-0 end-0 z-index-1 mt-n4 ms-n7">
                    <svg class="fill-warning" width="77px" height="77px">
                      <path d="M76.997,41.258 L45.173,41.258 L67.676,63.760 L63.763,67.673 L41.261,45.171 L41.261,76.994 L35.728,76.994 L35.728,45.171 L13.226,67.673 L9.313,63.760 L31.816,41.258 L-0.007,41.258 L-0.007,35.725 L31.816,35.725 L9.313,13.223 L13.226,9.311 L35.728,31.813 L35.728,-0.010 L41.261,-0.010 L41.261,31.813 L63.763,9.311 L67.676,13.223 L45.174,35.725 L76.997,35.725 L76.997,41.258 Z"></path>
                    </svg>
                </figure>
                <div class="card card-body shadow text-center align-items-center h-100">
                    <div class="icon-lg bg-orange bg-opacity-10 text-orange rounded-circle mb-2">
                      <svg width="1em" height="1em" viewBox="0 0 16 16" fill="currentColor" role="img" focusable="false" class="fs-5 mb-1">
                          <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855q-.215.403-.395.872c.705.157 1.472.257 2.282.287zM4.249 3.539q.214-.577.481-1.078a7 7 0 0 1 .597-.933A7 7 0 0 0 3.051 3.05q.544.277 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9 9 0 0 1-1.565-.667A6.96 6.96 0 0 0 1.018 7.5zm1.4-2.741a12.3 12.3 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332M8.5 5.09V7.5h2.99a12.3 12.3 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.6 13.6 0 0 1 7.5 10.91V8.5zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741zm-3.282 3.696q.18.469.395.872c.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a7 7 0 0 1-.598-.933 9 9 0 0 1-.481-1.079 8.4 8.4 0 0 0-1.198.49 7 7 0 0 0 2.276 1.522zm-1.383-2.964A13.4 13.4 0 0 1 3.508 8.5h-2.49a6.96 6.96 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667m6.728 2.964a7 7 0 0 0 2.275-1.521 8.4 8.4 0 0 0-1.197-.49 9 9 0 0 1-.481 1.078 7 7 0 0 1-.597.933M8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855q.216-.403.395-.872A12.6 12.6 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.96 6.96 0 0 0 14.982 8.5h-2.49a13.4 13.4 0 0 1-.437 3.008M14.982 7.5a6.96 6.96 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zM11.27 2.461q.266.502.482 1.078a8.4 8.4 0 0 0 1.196-.49 7 7 0 0 0-2.275-1.52c.218.283.418.597.597.932m-.488 1.343a8 8 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z"></path>
                      </svg>
                    </div>
                    <h5>Social media</h5>
                    <p>Sympathize Large above be to means.</p>
                    <ul class="list-inline mb-0 hstack gap-1 justify-content-center">
                      <li class="list-inline-item">
                          <a class="btn btn-sm bg-facebook px-2 mb-0" href="https://www.facebook.com/profile.php?id=61560476265259&mibextid=JRoKGi">
                            <svg class="svg-inline--fa fa-facebook-f fab fa-fw" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="facebook-f" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                <path class="" fill="currentColor" d="M80 299.3V512H196V299.3h86.5l18-97.8H196V166.9c0-51.7 20.3-71.5 72.7-71.5c16.3 0 29.4 .4 37 1.2V7.9C291.4 4 256.4 0 236.2 0C129.3 0 80 50.5 80 159.4v42.1H14v97.8H80z"></path>
                            </svg>
                          </a>
                      </li>
                      <li class="list-inline-item">
                          <a class="btn btn-sm bg-instagram px-2 mb-0" href="https://www.instagram.com/travelpradeshofficial/">
                            <svg class="svg-inline--fa fa-instagram fab fa-fw" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="instagram" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path class="" fill="currentColor" d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                            </svg>
                          </a>
                      </li>
                      <li class="list-inline-item">
                          <a class="btn btn-sm bg-twitter px-2 mb-0" href="https://twitter.com/travelpradesh">
                            <svg class="svg-inline--fa fa-twitter fab fa-fw" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="twitter" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                                <path class="" fill="currentColor" d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"></path>
                            </svg>
                          </a>
                      </li>
                      <li class="list-inline-item">
                          <a class="btn btn-sm bg-linkedin px-2 mb-0" href="https://linkedin.com/in/travelpradeshofficial">
                            <svg class="svg-inline--fa fa-linkedin fab fa-fw fa" aria-hidden="true" focusable="false" data-prefix="fab" data-icon="linkedin" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                                <path class="" fill="currentColor" d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
                            </svg>
                          </a>
                      </li>
                    </ul>
                </div>
              </div>
          </div>
        </div>
        <section className='pt-0 pt-lg-5'>
          <div class="container">
            <div class="row g-4 g-lg-5 align-items-center">
                <div class="col-lg-6 text-center">
                  <img src='../images/contact.svg' />
                </div>
                <div class="col-lg-6">
                  <div class="card bg-light p-4">
                      <div class="card-header bg-light p-0 pb-3">
                        <h3 class="mb-0">Send us message</h3>
                      </div>
                      <div class="card-body p-0">
                        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                          <Stack sx={{ py: 1 }}>
                            <RHFTextField size="small" name="name" label="Name" />
                          </Stack>
                          <Stack sx={{ py: 1 }}>
                            <RHFTextField size="small" name="email" label="Email" />
                          </Stack>
                          <Stack sx={{ py: 1 }}>
                            <RHFTextField size="small" type='number' name="mobile" label="Enter mobile" />
                          </Stack>
                          <Stack sx={{ py: 1 }}>
                            <LoadingButton fullWidth size="large" type="submit" className='signBtn' loading={isSubmitting}>
                              Submit
                            </LoadingButton>
                          </Stack>
                        </FormProvider>
                      </div>
                  </div>
                </div>
            </div>
          </div>
        </section>
      </section>
      <ToastContainer />
      <Footer />
    </>
  )
}

export default Contact
